import {createSelector} from "reselect";
import {getAllFundsList} from "../allFunds/allFunds.selectors";
import {stringPropSorter} from "../../../utils/utils";

/**
 * @param {Object} state
 * @returns {boolean}
 */
export const isExistingSet = state => state.shoppingCart.existingSet;

export const getSelectedDestination = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedDestination
);

export const getSelectedDistribution = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedDistributionMethod.type
);

export const getSelectedDistributionFunds = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => {
    return shoppingCart.selectedDistributionMethod.funds
  }
);

export const getSelectedBank = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedBank
);

export const getAddFundList = createSelector(
  getAllFundsList,
  (
    allFunds,
  ) => {
    return allFunds
      .filter(
        (fund) =>
          fund.ticker !== null &&
          fund.ticker !== '' &&
          fund.ticker.toUpperCase() !== 'ICFXX' &&
          fund.merged !== true &&
          !fund.iClass &&
          !(!fund.openToNewInvestors && !fund.openToSubsequentInvestments)
      ).sort(stringPropSorter((fund) => fund.name));
  }
);

export const getSelectedReinvestment = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedReinvestment
);

export const getSelectedMonths = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedMonths
);

export const getSelectedDay = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.selectedDay
);


export const getTaxWithholding = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.taxWithholding
);

export const getEstimateDate = createSelector(
  (state) => state.shoppingCart,
  (shoppingCart) => shoppingCart.estimateDate
);

export const getNumberWithOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'],
    v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
